import React from 'react';

export const BottomAction: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="w-fit pb-1">{children}</div>
);
